/// <amd-module name="SuiteCommerce.GiftCertificate.Shopping"/>
define("SuiteCommerce.GiftCertificate.Shopping", ["require", "exports", "underscore", "SuiteCommerce.GiftCertificate.Common.InstrumentationHelper", "SuiteCommerce.GiftCertificate.Utils.Configuration", "SuiteCommerce.GiftCertificate.Common.Utils", "SuiteCommerce.GiftCertificate.PDP", "SuiteCommerce.GiftCertificate.PLP", "SuiteCommerce.GiftCertificate.LandingPage.Router", "SuiteCommerce.GiftCertificate.Main.Configuration"], function (require, exports, _, InstrumentationHelper_1, Configuration_1, Utils_1, PDP, PLP, LandingPage_Router_1, Main_Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(container.getComponent('Environment'));
            this.initializeConfigurationComponent(container);
            if (Main_Configuration_1.MainConfiguration.enableGiftCertMyAccount) {
                this.addMenuTreeItem(container);
            }
            if (!Main_Configuration_1.MainConfiguration.enableGiftCertShopping) {
                return;
            }
            this.initializeUserProfileComponent(container);
            PLP.mountToApp(container);
            this.excludeFieldsFromFacets(this.getFieldsToExcludeFromFacets());
            this.initializeValueCheckRouter(container);
            this.initializePDPModules(container);
        },
        initializeConfigurationComponent: function (container) {
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            InstrumentationHelper_1.InstrumentationHelper.sendLogForDomainConfiguration();
        },
        initializeUserProfileComponent: function (container) {
            var userProfile = container.getComponent('UserProfile');
            if (userProfile) {
                userProfile
                    .getUserProfile()
                    .then(function (userProfileData) {
                    Utils_1.Utils.userProfileData = userProfileData;
                });
            }
        },
        getFieldsToExcludeFromFacets: function () {
            var fields = [
                'custitem_ns_sc_ext_only_pdp',
                'custitem_ns_sc_ext_gift_cert_group_id',
            ];
            if (Main_Configuration_1.MainConfiguration.hideInventoryTypesFromFacets) {
                fields.push('itemtype');
            }
            return fields;
        },
        excludeFieldsFromFacets: function (fields) {
            _.each(Configuration_1.Configuration.getSearchApiMasterOptions(), function (searchMasterOption) {
                _.each(fields, function (field) {
                    if (searchMasterOption['facet.exclude']) {
                        searchMasterOption['facet.exclude'] += ",".concat(field);
                    }
                    else {
                        searchMasterOption['facet.exclude'] = field;
                    }
                });
            });
        },
        addMenuTreeItem: function (container) {
            var myAccountMenuComponent = container.getComponent('MyAccountMenu');
            if (myAccountMenuComponent) {
                myAccountMenuComponent.addGroup({
                    id: 'MyAccountGiftCertificates',
                    name: 'Gift Certificates',
                    url: 'gift-certificates',
                    index: 3,
                });
            }
        },
        initializeValueCheckRouter: function (container) {
            new LandingPage_Router_1.LandingPageRouter({ application: container, routes: {} });
        },
        initializePDPModules: function (container) {
            PDP.mountToApp(container);
        },
    };
});
